/* PRO-94 deploy 1783576992 */
/* PRO-50 plausible bootstrap */
(function(){if(window.__paPlausible)return;window.__paPlausible=1;var s=document.createElement("script");s.defer=true;s.dataset.domain="projectaston.com";s.src="https://plausible.io/js/script.tagged-events.js";document.head.appendChild(s);window.plausible=window.plausible||function(){(window.plausible.q=window.plausible.q||[]).push(arguments)};})();
/**
 * Project Aston — Master JavaScript
 * All shared modules: header, menu, cart, variant picker, quantity,
 * back-to-top, intersection observer, accordions.
 * Vanilla JS, no jQuery. IIFE for each module.
 */
(function () {
  'use strict';

  /* ========================================
     Utility: Debounce
     ======================================== */
  function debounce(fn, ms) {
    var timer;
    return function () {
      var ctx = this;
      var args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(ctx, args);
      }, ms);
    };
  }

  /* ========================================
     Module: Stale PDP cache recovery (PRO-85)
     Canonical product URLs can serve pre-fix HTML without variant id/picker.
     ======================================== */
  (function initStalePdpRecovery() {
    if (!document.querySelector('.pa-pdp, [data-buy-buttons]')) return;

    var pathMatch = window.location.pathname.match(/^\/products\/([^/?#]+)\/?$/);
    if (!pathMatch || window.location.search.indexOf('variant=') !== -1) return;

    var form = document.querySelector('.pa-buy-buttons__form');
    var hasVariantId = form && (form.querySelector('[name="id"]') || form.querySelector('[data-variant-id-input]'));
    var hasPicker = document.querySelector('[data-variant-picker]');

    if (hasVariantId && hasPicker) return;

    fetch('/products/' + pathMatch[1] + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('product.js fetch failed');
        return res.json();
      })
      .then(function (product) {
        if (!product || !product.variants || product.variants.length <= 1) return;

        var variant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
        if (!variant) return;

        if (!hasPicker || !hasVariantId) {
          window.location.replace('/products/' + pathMatch[1] + '?variant=' + variant.id);
          return;
        }
      })
      .catch(function (err) {
        console.warn('[PDP] Stale cache recovery skipped:', err);
      });
  })();

  /* ========================================
     Module: Intersection Observer (fade-up)
     ======================================== */
  (function initIntersectionObserver() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-animate]').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );

    document.querySelectorAll('[data-animate]').forEach(function (el) {
      observer.observe(el);
    });
  })();

  /* ========================================
     Module: Header scroll behavior
     ======================================== */
  (function initHeaderScroll() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    var threshold = 20;
    var lastY = 0;

    window.addEventListener(
      'scroll',
      debounce(function () {
        var y = window.scrollY;
        if (y > threshold) {
          header.classList.add('pa-header--scrolled');
        } else {
          header.classList.remove('pa-header--scrolled');
        }
        lastY = y;
      }, 16),
      { passive: true }
    );
  })();

  /* ========================================
     Module: Mobile Menu Toggle
     ======================================== */
  (function initMenuToggle() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var panel = document.querySelector('[data-menu-panel]');
    var closeBtn = document.querySelector('[data-menu-close]');
    var overlay = document.querySelector('[data-menu-overlay]');

    if (!toggle || !panel) return;

    function openMenu() {
      panel.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      panel.classList.add('is-open');
      overlay.classList.add('is-open');
      document.body.classList.add('is-menu-open');
    }

    function closeMenu() {
      panel.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      panel.classList.remove('is-open');
      overlay.classList.remove('is-open');
      document.body.classList.remove('is-menu-open');
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      var isOpen = panel.getAttribute('aria-hidden') === 'false';
      isOpen ? closeMenu() : openMenu();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeMenu);
    }

    if (overlay) {
      overlay.addEventListener('click', closeMenu);
    }

    // Close on Escape
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel.getAttribute('aria-hidden') === 'false') {
        closeMenu();
      }
    });

    // Close when a menu link is clicked
    panel.addEventListener('click', function (e) {
      if (e.target.matches('.pa-menu-panel__link, .pa-menu-panel__sublink')) {
        closeMenu();
      }
    });
  })();

  /* ========================================
     Module: Cart Drawer
     ======================================== */
  (function initCartDrawer() {
    var triggers = document.querySelectorAll('[data-cart-trigger]');
    var drawer = document.querySelector('[data-cart-drawer]');
    var overlay = document.querySelector('[data-cart-overlay]');
    var closeBtn = document.querySelector('[data-drawer-close]');

    if (!drawer) return;

    function patchCheckoutLinks() {
      document.querySelectorAll('.pa-cart-drawer__checkout, .pa-cart__checkout-btn').forEach(function (el) {
        var href = el.getAttribute('href');
        if (!href || href === '#' || href.indexOf('/checkout') !== 0) {
          el.setAttribute('href', '/checkout');
        }
      });
    }

    function openCartDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.classList.add('is-open');
      document.body.classList.add('is-cart-open');
      patchCheckoutLinks();
    }

    function closeCartDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('is-open');
      document.body.classList.remove('is-cart-open');
    }

    triggers.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        fetchCartAndUpdate().then(function () {
          openCartDrawer();
        });
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', closeCartDrawer);
    }

    if (overlay) {
      overlay.addEventListener('click', closeCartDrawer);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeCartDrawer();
      }
    });

    // Expose globally for other modules
    window.PACart = {
      open: openCartDrawer,
      close: closeCartDrawer,
      refresh: fetchCartAndUpdate
    };

    /* ---- AJAX Cart Helpers ---- */
    function fetchCartAndUpdate() {
      return fetch('/cart.js')
        .then(function (res) {
          if (!res.ok) throw new Error('Cart fetch failed');
          return res.json();
        })
        .then(function (cart) {
          updateCartDrawer(cart);
          updateCartCount(cart.item_count);
        })
        .catch(function (err) {
          console.error('[Cart] Fetch error:', err);
        });
    }

    function updateCartCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
      });
    }

    function updateCartDrawer(cart) {
      var body = document.querySelector('[data-cart-body]');
      var subtotalEl = document.querySelector('[data-cart-subtotal]');

      if (!body) return;

      if (cart.items && cart.items.length > 0) {
        var itemsHtml = '<div class="pa-cart-drawer__items">';
        cart.items.forEach(function (item, idx) {
          var imgUrl = '';
          if (item.image) {
            imgUrl = item.image.url.replace(/\/\d+\//, '/160/');
          }
          itemsHtml +=
            '<div class="pa-cart-line" data-line-index="' + idx + '" data-key="' + item.key + '">' +
              '<div class="pa-cart-line__image">' +
                (imgUrl
                  ? '<img src="' + imgUrl + '" alt="' + (item.image && item.image.alt ? item.image.alt : item.product_title) + '" loading="lazy" width="72" height="96">'
                  : '<div class="pa-cart-line__placeholder"></div>') +
              '</div>' +
              '<div class="pa-cart-line__info">' +
                '<h3 class="pa-cart-line__title">' + item.product_title + '</h3>' +
                (item.variant_title !== 'Default Title' ? '<p class="pa-cart-line__variant">' + item.variant_title + '</p>' : '') +
                '<p class="pa-cart-line__price">' + formatMoney(item.line_price) + '</p>' +
                '<div class="pa-cart-line__qty">' +
                  '<button type="button" class="pa-qty-btn pa-qty-btn--minus" data-cart-qty-minus aria-label="Decrease quantity" data-cart-line-key="' + item.key + '">' +
                    '<svg viewBox="0 0 16 16" width="12" height="12" fill="currentColor"><rect x="2" y="7" width="12" height="2"/></svg>' +
                  '</button>' +
                  '<span class="pa-cart-line__qty-value">' + item.quantity + '</span>' +
                  '<button type="button" class="pa-qty-btn pa-qty-btn--plus" data-cart-qty-plus aria-label="Increase quantity" data-cart-line-key="' + item.key + '">' +
                    '<svg viewBox="0 0 16 16" width="12" height="12" fill="currentColor"><rect x="7" y="2" width="2" height="12"/><rect x="2" y="7" width="12" height="2"/></svg>' +
                  '</button>' +
                  '<a href="/cart/change?line=' + (idx + 1) + '&quantity=0" class="pa-cart-line__remove" data-cart-remove aria-label="Remove ' + item.product_title + '">Remove</a>' +
                '</div>' +
              '</div>' +
            '</div>';
        });
        itemsHtml += '</div>';

        body.innerHTML = itemsHtml;

        // Build footer
        var footer = drawer.querySelector('.pa-cart-drawer__footer');
        if (!footer) {
          footer = document.createElement('div');
          footer.className = 'pa-cart-drawer__footer';
          drawer.appendChild(footer);
        }
        footer.innerHTML = buildCartFooter(cart);

        // Attach new qty/remove handlers inside the drawer
        attachCartLineHandlers();
      } else {
        body.innerHTML =
          '<div class="pa-cart-drawer__empty">' +
            '<p class="pa-cart-drawer__empty-text">Your cart is empty</p>' +
            '<a href="/collections/all" class="pa-btn pa-btn--primary pa-btn--sm">Explore the Collection</a>' +
          '</div>';

        // Remove footer if present
        var oldFooter = drawer.querySelector('.pa-cart-drawer__footer');
        if (oldFooter) oldFooter.remove();
      }

      if (subtotalEl) {
        subtotalEl.textContent = formatMoney(cart.total_price);
      }

      patchCheckoutLinks();
    }

    function buildCartFooter(cart) {
      var html = '';
      if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
        cart.cart_level_discount_applications.forEach(function (d) {
          html += '<div class="pa-cart-discount"><span>' + d.title + '</span><span>-' + formatMoney(d.total_allocated_amount) + '</span></div>';
        });
      }
      html +=
        '<div class="pa-cart-drawer__subtotal">' +
          '<span class="pa-cart-drawer__subtotal-label">Subtotal</span>' +
          '<span class="pa-cart-drawer__subtotal-value" data-cart-subtotal>' + formatMoney(cart.total_price) + '</span>' +
        '</div>' +
        '<p class="pa-cart-drawer__note">Shipping and taxes calculated at checkout</p>' +
        '<a href="/checkout" class="pa-btn pa-btn--primary pa-cart-drawer__checkout">Proceed to Checkout</a>';
      return html;
    }

    function formatMoney(cents) {
      return (cents / 100).toFixed(2);
    }

    function attachCartLineHandlers() {
      // Quantity minus
      document.querySelectorAll('[data-cart-qty-minus]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = btn.closest('.pa-cart-line');
          if (!line) return;
          var qtyEl = line.querySelector('.pa-cart-line__qty-value');
          var currentQty = parseInt(qtyEl.textContent, 10);
          var key = btn.closest('.pa-cart-line').getAttribute('data-cart-line-key');
          if (currentQty > 1) {
            changeCartLineQty(key, currentQty - 1);
          } else {
            removeFromCartByLine(key);
          }
        });
      });

      // Quantity plus
      document.querySelectorAll('[data-cart-qty-plus]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var line = btn.closest('.pa-cart-line');
          if (!line) return;
          var qtyEl = line.querySelector('.pa-cart-line__qty-value');
          var currentQty = parseInt(qtyEl.textContent, 10);
          var key = btn.closest('.pa-cart-line').getAttribute('data-cart-line-key');
          changeCartLineQty(key, currentQty + 1);
        });
      });

      // Remove
      document.querySelectorAll('[data-cart-remove]').forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          var line = link.closest('.pa-cart-line');
          if (!line) return;
          var href = link.getAttribute('href');
          // Parse the key from data attribute or URL
          var key = line.getAttribute('data-cart-line-key');
          if (key) {
            removeFromCartByLine(key);
          }
        });
      });
    }

    function changeCartLineQty(key, newQty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: newQty })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          window.PACart.refresh();
        });
    }

    function removeFromCartByLine(key) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          window.PACart.refresh();
        });
    }

    patchCheckoutLinks();
    fetchCartAndUpdate();
  })();

  /* ========================================
     Module: Add to Cart (AJAX)
     ======================================== */
  (function initAddToCart() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-add-to-cart]');
      if (!btn) return;

      var form = btn.closest('form');
      if (!form) return;

      e.preventDefault();

      var variantInput = form.querySelector('[data-variant-id-input]') || form.querySelector('[data-variant-input]');
      var idInput = form.querySelector('[name="id"]');
      var variantId = variantInput && variantInput.value ? variantInput.value : (idInput ? idInput.value : '');
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

      if (!variantId) {
        console.error('[Cart] Missing variant id on product form');
        var missingTextEl = btn.querySelector('[data-add-to-cart-text]');
        if (missingTextEl) missingTextEl.textContent = 'Select options';
        else btn.textContent = 'Select options';
        return;
      }

      // Loading state
      btn.disabled = true;
      btn.setAttribute('data-loading', 'true');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          btn.textContent = 'Added!';
          setTimeout(function () {
            btn.disabled = false;
            btn.removeAttribute('data-loading');
            // Reset text
            var textEl = btn.querySelector('[data-add-to-cart-text]');
            if (textEl) textEl.textContent = 'Add to Cart';
            else btn.textContent = 'Add to Cart';
            // Refresh cart and open drawer
            if (window.PACart) {
              window.PACart.refresh().then(function () {
                window.PACart.open();
              });
            }
          }, 600);
        })
        .catch(function (err) {
          console.error('[Cart] Add error:', err);
          btn.textContent = 'Error — try again';
          btn.disabled = false;
          btn.removeAttribute('data-loading');
          setTimeout(function () {
            var textEl = btn.querySelector('[data-add-to-cart-text]');
            if (textEl) textEl.textContent = 'Add to Cart';
            else btn.textContent = 'Add to Cart';
          }, 2000);
        });
    });
  })();

  /* ========================================
     Module: Variant Picker
     ======================================== */
  (function initVariantPicker() {
    var pickers = document.querySelectorAll('[data-variant-picker]');

    pickers.forEach(function (picker) {
      var variantDataEl = picker.querySelector('[data-variants-json]');
      var variants = [];

      if (variantDataEl) {
        try {
          variants = JSON.parse(variantDataEl.textContent);
        } catch (e) {}
      }

      var variantInput = (picker.closest('form') || picker).querySelector('[data-variant-input], [data-variant-id-input]');
      var selectedOptions = {};

      // Initialize first options as selected
      picker.querySelectorAll('.pa-variant-picker__group').forEach(function (group) {
        var firstActive = group.querySelector('.pa-variant-picker__swatch--active, .pa-variant-picker__pill--active');
        if (firstActive) {
          var idx = firstActive.getAttribute('data-option-index');
          selectedOptions[idx] = firstActive.getAttribute('data-value');
        }
      });

      // Update submit button state based on initial selection
      updateSubmitButtonState(picker);

      // Click handler for swatches and pills
      picker.addEventListener('click', function (e) {
        var btn = e.target.closest('.pa-variant-picker__swatch, .pa-variant-picker__pill');
        if (!btn || btn.getAttribute('aria-disabled') === 'true') return;

        var group = btn.closest('.pa-variant-picker__group');
        var optionIndex = btn.getAttribute('data-option-index');
        var value = btn.getAttribute('data-value');

        // Set active
        group.querySelectorAll('.pa-variant-picker__swatch, .pa-variant-picker__pill').forEach(function (b) {
          b.classList.remove('pa-variant-picker__swatch--active', 'pa-variant-picker__pill--active');
        });
        btn.classList.add('pa-variant-picker__swatch--active', 'pa-variant-picker__pill--active');

        selectedOptions[optionIndex] = value;

        // Find matching variant
        var matchingVariant = findVariant(variants, selectedOptions);
        if (matchingVariant) {
          if (variantInput) {
            variantInput.value = matchingVariant.id;
          }

          // Update price if a price element exists
          var priceEl = document.querySelector('[data-product-price]');
          if (priceEl && matchingVariant.price != null) {
            priceEl.textContent = formatMoney(matchingVariant.price);
          }
        }

        // Update submit button state
        updateSubmitButtonState(picker, matchingVariant);
      });

      function updateSubmitButtonState(picker, variant) {
        var form = picker.closest('form');
        if (!form) return;
        var submitBtn = form.querySelector('[data-add-to-cart]');
        if (!submitBtn) return;
        var textEl = submitBtn.querySelector('[data-add-to-cart-text]');

        var target = variant || findVariant(variants, selectedOptions);

        if (target && target.available) {
          submitBtn.disabled = false;
          if (textEl) textEl.textContent = 'Add to Cart';
        } else {
          submitBtn.disabled = true;
          if (textEl) textEl.textContent = 'Sold Out';
        }
      }

      function findVariant(variants, options) {
        var keys = Object.keys(options);
        return variants.find(function (v) {
          return keys.every(function (k) {
            if (!v.options || v.options.length <= parseInt(k, 10)) return false;
            return v.options[parseInt(k, 10)] === options[k];
          });
        });
      }

      function formatMoney(cents) {
        return (cents / 100).toFixed(2);
      }
    });
  })();

  /* ========================================
     Module: Quantity +/- Controls
     ======================================== */
  (function initQuantityControls() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-minus], [data-qty-plus]');
      if (!btn) return;

      e.preventDefault();
      var form = btn.closest('form');
      var input = form ? form.querySelector('[data-qty-input]') : null;
      if (!input) return;

      var current = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10) || 1;

      if (btn.hasAttribute('data-qty-minus')) {
        input.value = Math.max(min, current - 1);
      } else if (btn.hasAttribute('data-qty-plus')) {
        input.value = current + 1;
      }

      // Trigger change event for any listeners
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  })();

  /* ========================================
     Module: Back to Top
     ======================================== */
  (function initBackToTop() {
    var btn = document.getElementById('pa-back-to-top');
    if (!btn) return;

    var threshold = 400;

    function toggleVisibility() {
      if (window.scrollY > threshold) {
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
    }

    window.addEventListener('scroll', debounce(toggleVisibility, 16), { passive: true });
    toggleVisibility(); // Check on load

    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  })();

  /* ========================================
     Module: Accordion
     ======================================== */
  (function initAccordions() {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-accordion-toggle]');
      if (!toggle) return;

      e.preventDefault();
      var item = toggle.closest('[data-accordion-item]');
      if (!item) return;

      var content = item.querySelector('[data-accordion-content]');
      if (!content) return;

      var inner = content.querySelector('[data-accordion-content-inner]');
      var isOpen = toggle.getAttribute('aria-expanded') === 'true';

      // Close sibling accordions (optional single-open mode)
      var parent = toggle.closest('[data-accordion-group]');
      if (parent) {
        parent.querySelectorAll('.pa-accordion-item--open [data-accordion-toggle]').forEach(function (otherToggle) {
          if (otherToggle !== toggle) {
            var otherItem = otherToggle.closest('[data-accordion-item]');
            var otherContent = otherItem.querySelector('[data-accordion-content]');
            otherToggle.setAttribute('aria-expanded', 'false');
            otherItem.classList.remove('pa-accordion-item--open');
            if (otherContent) {
              otherContent.style.maxHeight = '0px';
            }
          }
        });
      }

      if (isOpen) {
        toggle.setAttribute('aria-expanded', 'false');
        item.classList.remove('pa-accordion-item--open');
        content.style.maxHeight = '0px';
      } else {
        toggle.setAttribute('aria-expanded', 'true');
        item.classList.add('pa-accordion-item--open');
        content.style.maxHeight = inner ? inner.scrollHeight + 'px' : content.scrollHeight + 'px';
      }
    });
  })();

  /* ========================================
     Module: Carousel (Featured + Trust)
     ======================================== */
  (function initCarousels() {
    var carousels = document.querySelectorAll('[data-carousel]');

    carousels.forEach(function (carousel) {
      var track = carousel.querySelector('[data-carousel-track]');
      var prevBtn = carousel.querySelector('[data-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-carousel-next]');

      if (!track || (!prevBtn && !nextBtn)) return;

      function getScrollAmount() {
        var firstSlide = track.querySelector('.pa-carousel__slide');
        if (!firstSlide) return 300;
        var style = window.getComputedStyle(track);
        var gap = parseInt(style.gap, 10) || 0;
        return firstSlide.offsetWidth + gap;
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
        });
      }

      // Hide arrows when at scroll boundaries
      function updateArrowVisibility() {
        if (prevBtn) {
          prevBtn.style.display = track.scrollLeft <= 1 ? 'none' : '';
        }
        if (nextBtn) {
          var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
          nextBtn.style.display = atEnd ? 'none' : '';
        }
      }

      track.addEventListener('scroll', debounce(updateArrowVisibility, 100), { passive: true });
      window.addEventListener('resize', debounce(updateArrowVisibility, 100));

      // Initial check
      updateArrowVisibility();
    });
  })();

  /* ========================================
     Module: Cart Page Quantity Controls
     ======================================== */
  (function initCartPageQty() {
    document.addEventListener('click', function (e) {
      var minusBtn = e.target.closest('[data-cart-page-qty-minus]');
      var plusBtn = e.target.closest('[data-cart-page-qty-plus]');
      var removeBtn = e.target.closest('[data-cart-page-remove]');

      if (minusBtn) {
        e.preventDefault();
        var control = minusBtn.closest('.pa-qty-control');
        var lineKey = control.getAttribute('data-line-key');
        var input = control.querySelector('.pa-qty-control__input');
        var currentQty = parseInt(input.value, 10) || 1;
        if (currentQty > 1) {
          changeCartLineQty(lineKey, currentQty - 1);
        }
      }

      if (plusBtn) {
        e.preventDefault();
        var control = plusBtn.closest('.pa-qty-control');
        var lineKey = control.getAttribute('data-line-key');
        var input = control.querySelector('.pa-qty-control__input');
        var currentQty = parseInt(input.value, 10) || 1;
        if (currentQty < 99) {
          changeCartLineQty(lineKey, currentQty + 1);
        }
      }

      if (removeBtn) {
        e.preventDefault();
        var lineKey = removeBtn.getAttribute('data-line-key');
        var item = removeBtn.closest('.pa-cart__item');
        if (item) {
          item.classList.add('is-removing');
        }
        removeFromCartByKey(lineKey);
      }
    });

    // Manual input change
    document.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-page-qty-input]');
      if (!input) return;

      var lineKey = input.getAttribute('data-line-key');
      var newQty = parseInt(input.value, 10);
      if (isNaN(newQty) || newQty < 0) newQty = 0;
      if (newQty > 99) newQty = 99;
      changeCartLineQty(lineKey, newQty);
    });

    function changeCartLineQty(key, newQty) {
      var body = { key: key };
      if (newQty === 0) {
        body.quantity = 0;
      } else {
        body.quantity = newQty;
      }

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart update failed');
          return res.json();
        })
        .then(function () {
          location.reload();
        })
        .catch(function (err) {
          console.error('[Cart Page] Update error:', err);
          location.reload();
        });
    }

    function removeFromCartByKey(key) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ key: key, quantity: 0 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart update failed');
          return res.json();
        })
        .then(function () {
          location.reload();
        })
        .catch(function (err) {
          console.error('[Cart Page] Remove error:', err);
          location.reload();
        });
    }
  })();

  /* ========================================
     Module: PDP Gallery Thumbnail Switching
     Now supports colour-based image groups.
     When colour swatch is selected, shows only
     that colour's thumbnails and sets first as main.
     ======================================== */
  (function initPDPGallery() {
    var gallery = document.querySelector('.pa-pdp__gallery');
    if (!gallery) return;

    var mainImg = gallery.querySelector('.pa-pdp__image');
    var thumbsContainer = gallery.querySelector('[data-color-gallery]');
    if (!thumbsContainer) return;

    var allThumbs = thumbsContainer.querySelectorAll('.pa-pdp__thumb');
    if (allThumbs.length === 0) return;

    // Group thumbnails by colour
    var thumbsByColor = {};
    allThumbs.forEach(function (thumb) {
      var color = thumb.getAttribute('data-gallery-color');
      if (color) {
        if (!thumbsByColor[color]) thumbsByColor[color] = [];
        thumbsByColor[color].push(thumb);
      }
    });

    // Show thumbnails for a specific colour
    function showColorThumbs(color) {
      allThumbs.forEach(function (t) {
        t.style.display = 'none';
        t.classList.remove('pa-pdp__thumb--active');
      });
      var thumbs = thumbsByColor[color];
      if (thumbs && thumbs.length > 0) {
        thumbs.forEach(function (t) {
          t.style.display = '';
        });
        // Set first thumb of this colour as active and update main image
        var first = thumbs[0];
        updateMainImage(first);
        first.classList.add('pa-pdp__thumb--active');
      }
    }

    // Update main image from thumbnail data
    function updateMainImage(thumb) {
      var src = thumb.getAttribute('data-image-src');
      var srcset = thumb.getAttribute('data-image-srcset');
      var alt = thumb.getAttribute('aria-label');
      if (src && mainImg) {
        mainImg.src = src;
        mainImg.srcset = srcset;
      }
      if (alt) mainImg.alt = alt;
    }

    // Click handler for thumbnails
    thumbsContainer.addEventListener('click', function (e) {
      var thumb = e.target.closest('.pa-pdp__thumb');
      if (!thumb) return;
      
      allThumbs.forEach(function (t) {
        t.classList.remove('pa-pdp__thumb--active');
      });
      thumb.classList.add('pa-pdp__thumb--active');
      updateMainImage(thumb);
    });

    // Listen for variant picker colour changes
    var pickers = document.querySelectorAll('[data-variant-picker]');
    pickers.forEach(function (picker) {
      var variantDataEl = picker.querySelector('[data-variants-json]');
      if (!variantDataEl) return;

      // Find the color option index (usually position 2 = index 1)
      var optionGroups = picker.querySelectorAll('[data-option-index]');
      var colorGroup = null;
      optionGroups.forEach(function (g) {
        var label = picker.querySelector('[data-option-index="' + g.getAttribute('data-option-index') + '"]');
        if (label) {
          var labelEl = label.closest('.pa-variant-picker__group');
          if (labelEl) {
            var labelTitle = labelEl.querySelector('.pa-variant-picker__label');
            if (labelTitle) {
              var name = labelTitle.textContent.toLowerCase();
              if (name.indexOf('color') !== -1 || name.indexOf('colour') !== -1) {
                colorGroup = g.getAttribute('data-option-index');
              }
            }
          }
        }
      });

      // Override the picker click handler to also update gallery
      picker.addEventListener('click', function (e) {
        var btn = e.target.closest('.pa-variant-picker__swatch');
        if (!btn || btn.getAttribute('aria-disabled') === 'true') return;
        var color = btn.getAttribute('data-value');
        if (color && thumbsByColor[color]) {
          showColorThumbs(color);
        }
      });
    });

    // Show first colour on load
    var firstColor = Object.keys(thumbsByColor)[0];
    if (firstColor) {
      showColorThumbs(firstColor);
    }
  })();

  /* ========================================
     Module: Product Card Swatch Selection
     ======================================== */
  (function initProductCardSwatches() {
    document.addEventListener('click', function (e) {
      var swatch = e.target.closest('.pa-product-card__swatch');
      if (!swatch) return;

      var swatchesContainer = swatch.closest('.pa-product-card__swatches');
      if (!swatchesContainer) return;

      // Toggle selection within this group
      swatchesContainer.querySelectorAll('.pa-product-card__swatch').forEach(function (s) {
        s.classList.remove('is-selected');
      });
      swatch.classList.add('is-selected');
    });
  })();

})();
